<template>
  <v-layout column wrap style="overflow: hidden;">
    <v-toolbar dark class="toolbarcreatedadmin" style="margin-top: 20px;">
      <img :src="BASE_URL + 'static/icon/building.svg'" alt="" width="40px"> &nbsp;&nbsp;
      <v-toolbar-title>ข้อมูล หน่วยงาน</v-toolbar-title>
      <v-spacer></v-spacer>
      <div class="hidden-sm-and-down">
        <v-text-field
          hide-details
          solo
          v-model="search"
          append-icon="search"
          label="ค้นหาจากชื่อหน่วยงาน"
          class="textfieldSearch"
        ></v-text-field>
         <v-select
          :items="itemsselect"
          v-model="selectKey"
          item-text="text"
          item-value="value"
          solo
          hide-details
          ligth
          class="textfieldSelect"
        ></v-select>
      </div>
    </v-toolbar>
    <div class="hidden-md-and-up">
        <v-text-field
          hide-details
          solo
          v-model="search"
          append-icon="search"
          label="ค้นหาจากชื่อหน่วยงาน"
          class="textfieldSearch"
        ></v-text-field>
         <v-select
          :items="itemsselect"
          v-model="selectKey"
          item-text="text"
          item-value="value"
          solo
          hide-details
          ligth
          class="textfieldSelect"
        ></v-select>
      </div>
    <v-layout class="pb-4" row wrap justify-center align-center style="margin-top: 20px;">
      <!-- {{selectKey}} -->
      <v-data-table
        :headers="headers"
        :items="listCompanyFile"
        :items-per-page="limit"
        hide-default-footer
        :loading="table_loading"
        class="elevation-1 mx-4 data-table-container"
        @click:row="openModalEdit"
        style="cursor: pointer; width: 100%;"
        height="450px"
        fixed-header
      >
      <template v-slot:item.company_type="{ item }">
        <v-chip small v-if="item.company_type == 'owner'" style="background: #a80e00;color: white;">
          หน่วยงานในเครือสภากาชาด
        </v-chip>
        <v-chip small v-else-if="item.company_type == 'partner'"> หน่วยงานร่วมโครงการ </v-chip>
        <v-chip small v-else-if="item.company_type == 'maintenance'"> หน่วยงานบำรุงรักษาเครื่อง AED </v-chip>
        <!-- {{item.company_type}} -->
      </template> 
      
      <template v-slot:item.create_at="{ item }">
        {{ dateMoment(item.create_at)}} - {{ timeMoment(item.create_at)}}น.
      </template>
      <template v-slot:loading>
        <v-skeleton-loader type="table-row@10"></v-skeleton-loader>
      </template>
    </v-data-table>
    <v-pagination color="#a81000" v-model="page_pagination" :total-visible="7" :length="total_page"></v-pagination>
    </v-layout>
    <EditCompany :dialogedit_company="dialogedit_company" headid="" :Company="CompanyData" @closeedit_company="closeedit_company"></EditCompany>
  </v-layout>
</template>
<script>
var _ = require('lodash')
import { Decode, Momenttime } from '@/services'
import EditCompany from '@/components/edit/edit_company_modal'
export default {
  data () {
    return {
      dialogedit_company: false,
      BASE_URL: process.env.BASE_URL,
      items: [],
      selectKey: 'all',
      itemsselect: [
        { text: 'ทั้งหมด', value: 'all' },
        { text: 'หน่วยงานในเครือสภากาชาด', value: 'owner' },
        { text: 'หน่วยงานร่วมโครงการ', value: 'partner' },
        { text: 'หน่วยงานบำรุงรักษาเครื่อง AED', value: 'maintenance' }
      ],
      search: '',
      headers: [
        { text: 'ชื่อหน่วยงาน', value: 'company_name' },
        { text: 'ประเภทหน่วยงาน', value: 'company_type' },
        { text: 'วันเวลาที่สร้าง', value: 'create_at' }
      ],
      listCompany: [],
      CompanyData: {},
      page_pagination: 1,
      limit: 10,
      total_page: 0,
      table_loading: false
    }
  },
  created () {
    this.getlistCompany()
    if (this.$route.query.typeSearch == 'all' || this.$route.query.typeSearch == 'owner' || this.$route.query.typeSearch == 'partner' || this.$route.query.typeSearch == 'maintenance') {
      this.selectKey = this.$route.query.typeSearch
    }
  },
  components: {
    EditCompany
  },
  watch: {
    page_pagination () {
      // คำนวณข้อมูลที่จะแสดงตาม page
    },
    search () {
      this.page_pagination = 1
    },
    selectKey () {
      this.page_pagination = 1
    }
  },
  computed: {
    listCompanyFile () {
      let filtered = []
      if (this.search !== '' && this.search !== null) {
        filtered = _.reject(this.listCompanyMode, ['company_name', null]).filter(post => {
          try {
            return post.company_name.toLowerCase().includes(this.search.toLowerCase())
          } catch(err) {
          }
        })
      } else {
        filtered = this.listCompanyMode
      }

      // คำนวณ total_page
      this.total_page = Math.ceil(filtered.length / this.limit)

      // คำนวณข้อมูลที่จะแสดงตาม pagination
      const start = (this.page_pagination - 1) * this.limit
      const end = start + this.limit
      return filtered.slice(start, end)
    },
    listCompanyMode () {
      if (this.selectKey == 'all') {
        return this.listCompany
      } else {
        return this.listCompany.filter(post => {
            return post.company_type.toLowerCase().includes(this.selectKey.toLowerCase())
        })
      }
    }
  },
  methods: {
    closeedit_company (value, update) {
      this.dialogedit_company = value
      if (update) {
        this.getlistCompany()
      }
    },
    openModalEdit (item) {
      this.CompanyData = item
      this.dialogedit_company = true
    },
    dateMoment(data) {
      return Momenttime.momentdatethai(data)
    },
    timeMoment(data) {
      return Momenttime.momenttimethai(data)
    },
    getlistCompany () {
      this.table_loading = true
      this.$api.getAllCompany().then((response) => {
        this.listCompany = response.data.data
        // this.listCompany = _.sortBy(this.listCompany, function(dateObj) {
        //   return new Date(dateObj.create_at)
        // }).reverse()
        this.table_loading = false
      })
    }
  }
}
</script>
<style media="screen" scoped>
>>>.theme--dark.v-text-field--solo>.v-input__control>.v-input__slot {
    border-radius: 30px;
    background: #ffffff;
    color: #a80e00;
    border-color: #a80e00;
    border-style: solid;
    border-width: thin;
}
.inputinfor_address {
  height: 110px !important;
  border-width: thin !important;
  border-style: solid !important;
  border-color: #a80e00 !important;
  border-radius: 7px !important;
  background-color: white !important;
}
.inputinfor {
  height: 50px !important;
  border-width: thin !important;
  border-style: solid !important;
  border-color: #a80e00 !important;
  border-radius: 7px !important;
  background-color: white !important;
}
.inputinfor_dis {
  height: 50px !important;
  border-width: thin !important;
  border-style: solid !important;
  border-color: #a80e00 !important;
  border-radius: 7px !important;
  background-color: #FAF0F0 !important;
}
>>>.theme--dark.v-select .v-select__selections {
    color: #a80e00 !important;
}
>>>.theme--dark.v-label {
    color: hsl(5, 100%, 33%) !important;
}
>>>.theme--dark.v-icon {
    color: #a80e00 !important;
}
>>>.theme--dark.v-input:not(.v-input--is-disabled) input {
  color: #a80e00 !important;
}
>>>.v-select__selections {
  line-height: 26px !important;
}
>>>.v-select__selection--comma {
  color: #a80e00 !important;
}
>>>.v-input .v-label {
    height: 26px;
    line-height: 26px;
  }
>>>.v-list-item__title {
    line-height: 26px !important;
}
.toolbarcreatedadmin {
  border-top-color: transparent !important;
  border-left-color: transparent !important;
  border-width: thin !important;
  border-right-color: transparent !important;
  border-style: solid !important;
  height: 64px !important;
  border-left-style: initial !important;
  border-right-style: initial !important;
  border-radius: 0px !important;
  border-bottom-color: #a80e00 !important;
  background-color: white !important;
  color: #a80e00 !important;
  border-width: thin !important;
  box-shadow: none !important;
}
.textfieldSearch {
  width: 330px;
  display: -webkit-inline-box;
  margin-right: 20px;
}

.textfieldSelect {
  width: 200px;
  display: -webkit-inline-box;
  margin-right: 20px;
}
/* >>>.v-input__slot {
  border-radius: 10px !important;
  border-style: solid !important;
  border-width: thin !important;
  border-color: #a80f00 !important;
  background-color: #a80d0021 !important;
} */
.btngen {
  background-color: white !important;
  color: #a80f00 !important;
  border-color: #a80f00 !important;
  border-style: solid !important;
  border-width: thin !important;
  text-transform: none !important;
  width: 120px !important;
}
.btncreateuser {
  background-color: #a80f00 !important;
  color: #fafafa !important;
  border-color: #a80f00 !important;
  border-style: solid !important;
  border-width: thin !important;
  text-transform: none !important;
}
.btncreateuser:disabled {
  background-color: #a80f0099 !important;
  color: #fafafa9c !important;
  border-color: #a80f0091 !important;
  border-style: solid !important;
  border-width: thin !important;
}

.btncancle {
  background-color: #fafafa !important;
  color: #a80f00 !important;
  border-color: #a80f00 !important;
  border-style: solid !important;
  border-width: thin !important;
  width: 160px !important;
}
>>>.theme--light.v-data-table thead tr:last-child th {
    border-bottom: thin solid rgba(0,0,0,.12);
    background: #a80e00 !important;
    color: white !important;
}
>>>.v-data-table__wrapper {
    border-radius: 14px;
    overflow-x: auto;
}

>>>.data-table-container {
    width: 100%;
    max-width: 100%;
}

>>>.theme--light.v-data-table {
    border-radius: 14px !important;
    margin-bottom: 20px !important;
}
@media (min-width: 481px) and (max-width: 767px), (min-width: 320px) and (max-width: 480px), (min-width: 768px) and (max-width: 1024px)  {
  .textfieldSearch {
    width: 80vw;
    margin-top: 20px;
    display: -webkit-inline-box;
    margin-right: 20px;
    border-radius: 30px;
    background: #ffffff;
    color: #a80e00;
    border-color: #a80e00;
    border-style: solid;
    border-width: thin;
  }
  .textfieldSelect {
    width: 80vw;
    margin-top: 20px;
    display: -webkit-inline-box;
    margin-right: 20px;
     border-radius: 30px !important;
    background: #ffffff !important;
    color: #a80e00 !important;
    border-color: #a80e00 !important;
    border-style: solid !important;
    border-width: thin !important;
  }

}

>>>.primary {
    background-color: #a81000 !important;
    border-color: #a81000 !important;
}

>>>.theme--light.v-data-table tbody tr:hover:not(.v-data-table__expanded__content):not(.v-data-table__empty-wrapper) {
    background: #ffe6e6 !important;
    cursor: pointer;
}

/* >>>.theme--light.v-btn.v-btn--disabled:not(.v-btn--icon):not(.v-btn--flat):not(.v-btn--outline) {
  background-color: #a80f0099 !important;
  color: #fafafa9c !important;
  border-color: #a80f0091 !important;
  border-style: solid !important;
  border-width: thin !important;
} */
</style>



// WEBPACK FOOTER //
// src/components/listReport/Listcompany.vue